const setClickedUrl = (state, payload) => {
  state.clickedUrl = payload
}

export default {
  setClickedUrl,
}
